import React from 'react';
import { Link } from 'react-router-dom';
import SeoLandingLayout from '../../components/SeoLandingLayout/SeoLandingLayout';

const CANONICAL = 'https://e-asy.es/consultoria-tecnologica-tenerife';

const SERVICE_LD = {
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  name: 'Consultoría tecnológica E-ASY',
  description:
    'Consultoría tecnológica en Tenerife: ERP, automatización de procesos e integración de sistemas para pymes y ONG, con acompañamiento en la implantación.',
  url: CANONICAL,
  serviceType: 'Consultoría tecnológica',
  provider: {
    '@type': 'Organization',
    name: 'E-ASY',
    url: 'https://e-asy.es',
  },
  areaServed: [
    { '@type': 'AdministrativeArea', name: 'Canarias' },
    { '@type': 'Country', name: 'España' },
  ],
};

const FAQ = [
  {
    question: '¿Solo trabajan en Tenerife?',
    answer:
      'La base es Tenerife y Canarias, pero acompañamos proyectos en toda España en remoto y con desplazamientos cuando hace falta. Lo importante es encajar con tu equipo, no el código postal por sí solo.',
  },
  {
    question: '¿Qué diferencia nuestra consultoría de comprar software solo?',
    answer:
      'Vendemos acompañamiento y criterio: qué implantar, en qué orden y cómo formar al equipo. El software —incluido nuestro Vulpin 360 cuando encaja— es medio, no fin.',
  },
  {
    question: '¿Necesito un ERP a medida?',
    answer:
      'No siempre. A veces el valor está en ordenar datos, integrar lo que tienes o elegir un ERP modular bien configurado. Te diremos qué encaja sin inflar el proyecto.',
  },
  {
    question: '¿Cómo es el proceso de implantación?',
    answer:
      'Diagnóstico breve, propuesta clara con fases, entregas que se puedan usar y formación continua. Sin sorpresas de “alcance infinito” a mitad de camino.',
  },
];

const ConsultoriaTecnologicaTenerifePage = ({ darkMode, toggleDarkMode }) => (
  <SeoLandingLayout
    darkMode={darkMode}
    toggleDarkMode={toggleDarkMode}
    title="Consultoría tecnológica en Tenerife | ERP, automatización e integración | E-ASY"
    description="Consultoría tecnológica en Tenerife para pymes y ONG: ERP, software de gestión, automatización de procesos e integración de sistemas. Acompañamiento real, no solo licencias."
    keywords="consultoría tecnológica Tenerife, consultoría digital Canarias, consultoría ERP Tenerife, implantación software empresa, partner tecnológico pyme"
    canonical={CANONICAL}
    h1="Consultoría tecnológica en Tenerife: ERP, automatización e integración"
    lede="E-ASY es consultoría tecnológica con sede en Tenerife. Ayudamos a pymes y entidades sociales cuando la gestión se complica: Excel agotado, herramientas desconectadas o un ERP que no refleja cómo trabajas."
    faqItems={FAQ}
    serviceJsonLd={SERVICE_LD}
    serviceJsonLdId="jsonld-service-consultoria-tfe"
  >
    <h2>Cuando necesitas adaptar el software a tu forma de trabajar</h2>
    <p>
      No se trata de cambiar cómo trabajas para cuadrar con un manual cerrado.
      Partimos de tus procesos reales y buscamos un encaje razonable entre
      configuración, integraciones y, si hace falta, desarrollo a medida.
    </p>

    <h2>Qué cubre nuestra consultoría tecnológica</h2>
    <ul>
      <li>
        <Link to="/erp-para-pymes">ERP y software de gestión para pymes</Link>
      </li>
      <li>
        <Link to="/erp-para-ong">Software de gestión para ONG</Link>
      </li>
      <li>
        <Link to="/vulpin">Vulpin Suite</Link>
        {' '}(gestión y flujos de administración incluidos)
      </li>
      <li>
        <Link to="/integracion-sistemas">Integración de sistemas</Link>
      </li>
    </ul>

    <h2>Vulpin Suite como prueba de capacidad, no como única opción</h2>
    <p>
      Desarrollamos{' '}
      <Link to="/vulpin" className="vulpin-inline-link">
        Vulpin Suite
      </Link>
      , un ERP modular (Business, Social, Care, Corps). Cuando encaja, acelera porque
      ya conocemos el producto a fondo. Cuando no encaja, no te venderemos
      humo: trabajamos con otras plataformas o con integración sobre lo
      existente.
    </p>

    <p>
      Si el proyecto no es presencial en la isla, el alcance remoto está en{' '}
      <Link to="/donde-trabajamos">dónde trabajamos</Link>.
    </p>
    <p>
      <Link to="/contacto" className="seo-landing-cta">
        Solicitar una demo adaptada
      </Link>
    </p>
  </SeoLandingLayout>
);

export default ConsultoriaTecnologicaTenerifePage;
